module.exports = __webpack_public_path__ + "static/media/facebook.aa3def2c.svg";